<script lang="ts">
  import { onMount } from "svelte";
  import { activeTab, auth, bootSequence, det, AUTH_REQUIRED } from "./lib/stores";
  import Header from "./components/Header.svelte";
  import TabBar from "./components/TabBar.svelte";
  import AnalysisTab from "./components/AnalysisTab.svelte";
  import LeanTab from "./components/LeanTab.svelte";
  import WbsTab from "./components/WbsTab.svelte";
  import RiskTab from "./components/RiskTab.svelte";
  import ManagementSummaryTab from "./components/ManagementSummaryTab.svelte";
  import UsersTab from "./components/UsersTab.svelte";
  import EditModal from "./components/EditModal.svelte";
  import LoginModal from "./components/LoginModal.svelte";
  import ProfileModal from "./components/ProfileModal.svelte";
  import PhasesModal from "./components/PhasesModal.svelte";
  import Toast from "./components/Toast.svelte";

  let ready = false;

  onMount(async () => {
    await bootSequence();
    ready = true;
  });

  // Reactive on the auth store (not just the initial boot check) so a successful
  // sign-in from the login modal immediately reveals the app without a reload,
  // and a session-expiry mid-session (handleSessionExpired) brings the modal back.
  $: needsLogin = ready && AUTH_REQUIRED && !$auth;
</script>

<div class="viz-root" class:wide={ready && ($activeTab === "lean" || $activeTab === "wbs")}>
  <Header />

  {#if !$det.ok}
    <div class="banner" id="errorBanner">
      <span class="dot"></span>
      <div><b>Can't compute the schedule.</b> {$det.error}</div>
    </div>
  {/if}

  {#if ready && !needsLogin}
    <TabBar />

    {#if $activeTab === "analysis"}
      <AnalysisTab />
    {:else if $activeTab === "lean"}
      <LeanTab />
    {:else if $activeTab === "wbs"}
      <WbsTab />
    {:else if $activeTab === "risks"}
      <RiskTab />
    {:else if $activeTab === "briefing"}
      <ManagementSummaryTab />
    {:else if $activeTab === "users"}
      <UsersTab />
    {/if}
  {/if}

  <footer>
    Source: <span class="mono">LEAN planning full scope v1.0.xlsx</span> and the P10/P50/P90 bandwidth tool, in
    <span class="mono">03. Projectbeheersing / 01. Planning / 01. Crane Control Upgrade (ABB) / 1. LEAN planning</span>.
    Method: forward/backward-pass CPM for the deterministic critical path; Monte Carlo simulation (triangular distribution
    per activity from O/M/P, default 2,000 iterations) for the probabilistic total duration — this correctly captures
    "merge bias" (parallel paths converging), which a simple sum-of-critical-path PERT calculation cannot.
    {#if !AUTH_REQUIRED}
      Nothing here is saved automatically — export the table before closing the tab, or edit together on one screen
      during the ABB session.
    {/if}
  </footer>
</div>

{#if needsLogin}
  <LoginModal />
{/if}

<EditModal />
<ProfileModal />
<PhasesModal />
<Toast />
